import configApi from '../../api/config'

const config = {
  namespaced: true,
  state: {
    config: null,
    fetchConfigPromise: null,
  },
  mutations: {
    setConfig(state, payload) {
      state.config = payload
    },
    setFetchPromise(state, payload) {
      state.fetchConfigPromise = payload
    },

  },
  actions: {
    async loadConfig({ commit, state }) {
      if (state.config !== null) {
        return state.config
      }
      if (state.fetchConfigPromise) {
        return state.fetchConfigPromise
      }
      const fetchConfigPromise = configApi.getConfig().then((c) => {
        commit('setConfig', c)
      })
      commit('setFetchPromise', fetchConfigPromise)
      return fetchConfigPromise
    },
  },
  getters: {
    config(state) {
      return state.config
    },
    configForKey: (state) => (key) => {
      if (state.config === null) {
        return null
      }

      const entry = state.config.find((e) => e.resourcename === key)
      if (!entry || !entry.resourcevalue) {
        return null
      }
      return JSON.parse(entry.resourcevalue)
    },
  },
}

export default config
